import React from 'react'

export const FlagMainPhotoSvg = ({ size = '24' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <rect width={size} height={size} fill="#F56323" rx="12" />
      <path fill="#FFF" d="M8.5 13V6h9l-2.725 3.5L17.5 13z" />
      <path stroke="#FFF" strokeWidth="1.5" d="M8.5 6v12" />
    </g>
  </svg>
)
